import { toJson } from '@/src/lib/SmartDB/Commons/utils';
import { SwapOfferStatsDashboardResponse } from '../../BackEnd/SwapOffer/SwapOfferStats.types';
import { SwapOfferEntity } from '../../Entities/SwapOffer.Entity';
import { SmartDBApi } from '../index.exports';
import { fetchWrapper } from '@/src/lib/SmartDB/lib/FetchWrapper';

export class SwapOfferApi extends SmartDBApi {
    protected static _Entity = SwapOfferEntity;

    // #region api

    public static async getStatsApi<T extends SwapOfferEntity>(paramsFilter?: Record<string, any>): Promise<SwapOfferStatsDashboardResponse> {
        try {
            const body = toJson({ paramsFilter });
            const response = await fetchWrapper(`${process.env.NEXT_PUBLIC_REACT_SERVER_API_URL}/${SwapOfferEntity.apiRoute()}/stats`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body,
            });
            if (response.status === 200) {
                const data = await response.json();
                console.log(`[${SwapOfferEntity.className()}] - getStatsApi - response OK`);
                return data;
            } else {
                const errorData = await response.json();
                //throw `Received status code ${response.status} with message: ${errorData.error.message ? errorData.error.message : errorData.error}`;
                throw `${errorData.error.message ? errorData.error.message : errorData.error}`;
            }
        } catch (error) {
            console.log(`[${SwapOfferEntity.className()}] - getStatsApi - Error: ${error}`);
            throw error;
        }
    }

    // #endregion api
}
